import {
    ApplicationRef,
    Component,
    Input,
    OnInit,
    ViewChild,
    Output,
    EventEmitter,
} from '@angular/core';
import {
    ChannelRepository,
    MessageRepository,
    ReactorRepository,
} from 'eko-sdk';
import {CdkVirtualScrollViewport} from '@angular/cdk/scrolling';
import {LikeAnimationComponent} from '../like-animation/like-animation.component';

@Component({
    selector: 'app-live-message',
    templateUrl: './live-message.component.html',
    styleUrls: ['./live-message.component.scss'],
})
export class LiveMessageComponent implements OnInit {
    @ViewChild(CdkVirtualScrollViewport) viewPort: CdkVirtualScrollViewport;
    @ViewChild(LikeAnimationComponent) animationCom: LikeAnimationComponent;

    @Input() channelId: string;
    @Input() userId: string;
    @Input() displayName: string;
    @Input() isSeller: boolean;
    @Output() viewAmountToViewer = new EventEmitter<any>();

    private channelRepo: ChannelRepository;
    private messageRepo: MessageRepository;
    private messageTagRepo: MessageRepository;

    messages: {
        id: string;
        date: Date;
        text: string;
        sender: string;
    }[] = [];
    messagesChat: string;
    messagesDefaultId: string[];
    private firstMessage: any;
    private reactionRepo: any;
    likeCount = '0';
    viewAmount = 0;
    animationId: string;
    likeRound = [];

    constructor(private appRef: ApplicationRef) {
        setTimeout(() => {
            this.viewPort.scrollToIndex(20, 'auto');
        }, 1000);
    }

    ngOnInit(): void {
        this.channelRepo = new ChannelRepository();
        this.channelRepo.joinChannel({
            channelId: this.channelId,
            type: 'standard',
        });

        this.messageRepo = new MessageRepository();
        this.messageTagRepo = new MessageRepository();

        const messages = this.messageRepo.messagesForChannel({
            channelId: this.channelId,
            tags: ['message'],
        });

        const messagesFilterTag = this.messageTagRepo.messagesForChannel({
            channelId: this.channelId,
            tags: ['like'],
        });
        messages.on('dataUpdated', (serverMessages) => {
            this.addMessage(serverMessages);
        });
        messagesFilterTag.on('dataUpdated', (serverMessages) => {
            if (serverMessages && serverMessages.length > 0) {
                this.addMessageDefaultId(serverMessages);
                this.firstMessage = this.messageTagRepo.messageForId(
                    this.messagesDefaultId[0]
                );
                this.likeCount = this.firstMessage.model.reactions.like;

                this.reactionRepo = new ReactorRepository(this.firstMessage.model);
                this.reactionRepo.addReaction('view');

                this.viewAmount = this.firstMessage.model.reactions.view + 1;

                this.viewAmountToViewer.emit(this.viewAmount);

                if (this.firstMessage.loadingStatus === 'loaded') {
                    this.appRef.tick();
                }
            }
        });
    }

    private addMessageDefaultId(serverMessages): void {
        this.messagesDefaultId = serverMessages.map((serverMessage) => {
            return serverMessage.messageId;
        });
        this.appRef.tick();
    }

    private addMessage(serverMessages): void {
        this.messages = serverMessages
            .map((serverMessage) => {
                return {
                    id: serverMessage.messageId,
                    date: serverMessage.createdAt,
                    text: serverMessage.data.text,
                    sender: serverMessage.user.model.displayName,
                };
            })
            .reverse();
        this.appRef.tick();
    }

    sendMessage(value: string): void {
        if (value) {
            this.messageRepo.createTextMessage({
                channelId: this.channelId,
                text: value,
                tags: ['message']
            });
            this.viewPort.scrollToIndex(20, 'auto');
        }
        this.messagesChat = '';
    }

    like(): void {
        this.reactionRepo.addReaction('like');
    }

    animationToggle(): void {
        this.generateId();
        this.likeRound.push("1");
    }

    removeIndex(event) {
        setTimeout(() => {
          this.likeRound.splice(event, 1);
        }, 1600);
    }

    generateId () {
        this.animationId = 'heart_' + Math.random().toString(36).substr(2, 9);
    };
}
